import React, { useMemo } from 'react';
import { IProductPromotion } from '../../../actions/DataServiceEntities.g';

type Props = {
    sitePath?: string;
    promotions?: IProductPromotion[];
};

const Promotions = ({ sitePath, promotions }: Props) => {
    const importantPromos = useMemo(() => {
        return promotions?.filter(p => p.IsImportant) ?? [];
    }, [promotions]);

    if (promotions && promotions.length > 0) {
        const heading = promotions.length > 1 ? `${promotions.length} Special Offers Available!` : '1 Special Offer Available!';
        return (
            <div className='hei-buybox-promotion'>
                <div className='hei-buybox-promotion-heading'>{heading}</div>
                {importantPromos.length > 0 && (
                    <ul className='hei-buybox-promotion-list'>
                        {importantPromos
                            .filter(p => p.IsImportant)
                            .map(o => {
                                return (
                                    <li key={o.OfferId} className='hei-buybox-promotion-item' data-offer={o.OfferId}>
                                        <a href={`${sitePath ?? ''}/promotion/${o.OfferId?.toLowerCase()}`}>{o.Name}</a>
                                    </li>
                                );
                            })}
                    </ul>
                )}
                <a className='hei-buybox-promotion-link' href='#offers'>
                    See all offers
                </a>
            </div>
        );
    }

    return null;
};

export { Promotions };
